import { UrlState } from '@shared/overlays/present-disposal-overlay/PresentDisposalOverlay.context';
import { getQueriesAsSearchNew } from '@shared/utils/common';
// import { generateRoutePaths } from '@shared/utils/route';

const disposalsManage = {
  rootPath: '/disposals/:id',
  root: (disposalId: string) => disposalsManage.rootPath.replace(':id', disposalId),

  activity: '/activity',
  insights: '/insights',
  management: '/management',
  reporting: '/reporting',
  summary: '/summary',
  viewings: '/viewings',
} as const;

export type DisposalManagePage = ValueOf<typeof disposalsManage>;

const organisation = {
  agents: {
    root: '/agents',
  },
  dashboard: '/dashboard',
  disposals: {
    root: '/disposals',
    manage: disposalsManage,
  },
  ias_events: '/ias-events',
  integrations: {
    root: '/integrations',
  },
  viewings: {
    root: '/viewings',
  },
  settings: {
    root: '/settings',
    password: '/password',
    profile: '/profile',
  },
  scheduleInvites: {
    root: '/schedule-invites',
  },
};

const present = {
  root: '/present',
  disposal: {
    rootPath: '/present/disposal/:id',
    root: (id: string, queryParams?: UrlState) => {
      const basePath = present.disposal.rootPath.replace(':id', id);

      if (!queryParams) {
        return basePath;
      }

      return `${basePath}?${getQueriesAsSearchNew(queryParams)}`;
    },
    configure: '/configure',
  },
};

const styleGuide = {
  root: '/style-guide',
  activity: '/activity',
  alerts: '/alerts',
  badges: '/badges',
  buttons: '/buttons',
  dropdowns: '/dropdowns',
  icons: '/icons',
};

const ROUTES = {
  initial: '/',
  logOut: '/logout',
  defaultRedirect: '/dashboard',

  organisation,

  present,

  styleGuide,
} as const;

export const routeTitles = {
  [ROUTES.initial]: '',

  [organisation.agents.root]: 'Agents | IAS',
  [organisation.ias_events]: 'Events | IAS',

  [organisation.dashboard]: 'Home',

  [organisation.disposals.root]: 'Disposals',

  [`${disposalsManage.rootPath}${disposalsManage.activity}`]: 'Activity | Disposal',
  [`${disposalsManage.rootPath}${disposalsManage.insights}`]: 'Insights | Disposal',
  [`${disposalsManage.rootPath}${disposalsManage.management}`]: 'Management | Disposal',
  [`${disposalsManage.rootPath}${disposalsManage.reporting}`]: 'Interest Schedule | Disposal',
  [`${disposalsManage.rootPath}${disposalsManage.summary}`]: 'Summary | Disposal',
  [`${disposalsManage.rootPath}${disposalsManage.viewings}`]: 'Viewings | Disposal',

  [organisation.integrations.root]: 'Integrations',

  [ROUTES.logOut]: 'Logout',

  [present.root]: 'Present',
  [present.disposal.rootPath]: 'Disposal | Present',
  [`${present.disposal.rootPath}${present.disposal.configure}`]: 'Configure | Disposal | Present',

  [organisation.scheduleInvites.root]: 'Schedule invites',

  [organisation.settings.root]: 'Account Settings',
  [`${organisation.settings.root}${organisation.settings.password}`]: 'Password | Account Settings',
  [`${organisation.settings.root}${organisation.settings.profile}`]: 'Profile | Account Settings',

  [styleGuide.root]: 'Style guide',
  [`${styleGuide.root}${styleGuide.activity}`]: 'Activity | Style guide',
  [`${styleGuide.root}${styleGuide.badges}`]: 'Badges | Style guide',
  [`${styleGuide.root}${styleGuide.buttons}`]: 'Buttons | Style guide',
  [`${styleGuide.root}${styleGuide.dropdowns}`]: 'Dropdowns | Style guide',
  [`${styleGuide.root}${styleGuide.icons}`]: 'Icons | Style guide',

  [organisation.viewings.root]: 'Viewings',
} as const;

// TODO: Used for outputting object of all paths, to aid with maintaining above (find missing keys)
// const list = generateRoutePaths(ROUTES).sort();
// console.log(list.reduce((result, value) => {
//   result[value] = '';
//   return result;
// }, {} as Record<string, string>));

export default ROUTES;
